import React from "react";
import _ from 'lodash';

export const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = React.useState(config);

  const sortedItems = React.useMemo(() => {
    let sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const sortConfigKey = sortConfig.key
        if (_.get(a, sortConfigKey, '') < _.get(b, sortConfigKey, '')) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (_.get(a, sortConfigKey, '') > _.get(b, sortConfigKey, '')) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};
